<div class="rl-page rl-skel sk-fade" *ngIf="loading">
  <div class="rl-stats-bar">
    <div class="rl-stats-grid">
      <div class="rl-stat-card" *ngFor="let s of [1,2,3,4]" style="display:flex;align-items:center;gap:14px">
        <span class="sk" style="width:44px;height:44px;border-radius:12px"></span>
        <div class="sk-stack" style="gap:8px;flex:1">
          <span class="sk-line" style="width:44px;height:20px"></span>
          <span class="sk-line sk-sm" style="width:80px"></span>
          <span class="sk-line sk-sm" style="width:120px"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="rl-tabs-bar">
    <div style="display:flex;gap:10px">
      <span class="sk" style="width:160px;height:34px;border-radius:8px"></span>
      <span class="sk" style="width:70px;height:34px;border-radius:8px"></span>
    </div>
    <span class="sk-btn" style="width:120px;margin-left:auto"></span>
  </div>
  <div class="rl-grid">
    <div class="rl-card" *ngFor="let c of [1,2,3,4,5,6]">
      <div class="rl-card-head">
        <span class="sk" style="width:44px;height:44px;border-radius:12px"></span>
        <div style="display:flex;gap:6px;margin-left:auto">
          <span class="sk" style="width:30px;height:30px;border-radius:8px"></span>
          <span class="sk" style="width:30px;height:30px;border-radius:8px"></span>
        </div>
      </div>
      <div class="rl-card-body">
        <span class="sk-line" style="width:55%;height:16px"></span>
        <span class="sk-line sk-sm" style="width:85%;margin-top:10px"></span>
        <span class="sk-line sk-sm" style="width:68%;margin-top:6px"></span>
        <div style="display:flex;gap:8px;margin-top:14px">
          <span class="sk-chip" style="width:72px"></span>
          <span class="sk-chip" style="width:80px"></span>
          <span class="sk-chip" style="width:56px"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="rl-page" *ngIf="!loading">

  <ng-container *ngIf="!showDialog">

  <div class="rl-stats-bar">
    <div class="rl-stats-grid">

      <div class="rl-stat-card rl-sc-roles">
        <div class="rl-sc-icon"><mat-icon>admin_panel_settings</mat-icon></div>
        <div class="rl-sc-body">
          <div class="rl-sc-val">{{ roles.length }}</div>
          <div class="rl-sc-lbl">Total Roles</div>
          <div class="rl-sc-sub">{{ activeRoleCount }} active · {{ systemRoleCount }} system</div>
        </div>
      </div>

      <div class="rl-stat-card rl-sc-users">
        <div class="rl-sc-icon"><mat-icon>people</mat-icon></div>
        <div class="rl-sc-body">
          <div class="rl-sc-val">{{ users.length }}</div>
          <div class="rl-sc-lbl">Total Users</div>
          <div class="rl-sc-sub"><span class="rl-sc-ok">{{ activeUsersCount }} active</span> · <span class="rl-sc-off">{{ inactiveUsersCount }} inactive</span></div>
        </div>
      </div>

      <div class="rl-stat-card rl-sc-hr">
        <div class="rl-sc-icon"><mat-icon>manage_accounts</mat-icon></div>
        <div class="rl-sc-body">
          <div class="rl-sc-val">{{ hrUsersCount }}</div>
          <div class="rl-sc-lbl">HR Members</div>
          <div class="rl-sc-sub">Managing people operations</div>
        </div>
      </div>

      <div class="rl-stat-card rl-sc-emp">
        <div class="rl-sc-icon"><mat-icon>badge</mat-icon></div>
        <div class="rl-sc-body">
          <div class="rl-sc-val">{{ employeeUsersCount }}</div>
          <div class="rl-sc-lbl">Employees</div>
          <div class="rl-sc-sub">Standard access level</div>
        </div>
      </div>

    </div>
  </div>

  <div class="rl-tabs-bar">
    <div class="rl-tabs" *ngIf="mode === 'both'">
      <button class="rl-tab" [class.rl-tab-active]="activeTab === 'users'" (click)="switchTab('users')">Users</button>
      <button class="rl-tab" [class.rl-tab-active]="activeTab === 'roles'" (click)="switchTab('roles')">Roles &amp; Permissions</button>
    </div>
    <button class="rl-btn rl-btn-primary" (click)="openCreate()" *ngIf="activeTab === 'roles'">
      <mat-icon>add</mat-icon> Create Role
    </button>
  </div>

  <ng-container *ngIf="activeTab === 'roles'">

    <div class="rl-empty" *ngIf="roles.length === 0">
      <div class="rl-empty-icon"><mat-icon>admin_panel_settings</mat-icon></div>
      <h3>No roles yet</h3>
      <p>Create your first role to control access permissions across the system.</p>
      <button class="rl-btn rl-btn-primary" (click)="openCreate()">
        <mat-icon>add</mat-icon> Create Role
      </button>
    </div>

    <div class="rl-table-wrap" *ngIf="roles.length > 0">
      <table class="rl-table">
        <thead>
          <tr>
            <th>Role</th>
            <th>Type</th>
            <th class="rl-c-n">Menus</th>
            <th class="rl-c-n">Modules</th>
            <th>Status</th>
            <th class="rl-c-act">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let role of roles"
              class="rl-row"
              [class.rl-row-selected]="showDialog && drawerMode === 'view' && selectedRole?.id === role.id"
              (click)="selectRole(role)">
            <td>
              <div class="rl-role-cell">
                <div class="rl-role-icon" [style.background]="getRoleColor(role) + '15'" [style.color]="getRoleColor(role)">
                  <mat-icon>{{ getRoleIcon(role) }}</mat-icon>
                </div>
                <div class="rl-role-cell-info">
                  <div class="rl-role-name">{{ role.displayName || role.name }}</div>
                  <div class="rl-role-desc">{{ role.description || 'No description' }}</div>
                </div>
              </div>
            </td>
            <td>
              <span class="rl-type-badge" [class.rl-type-system]="role.isSystem">{{ role.isSystem ? 'System' : 'Custom' }}</span>
            </td>
            <td class="rl-c-n">
              <span class="rl-badge rl-badge-menu"><mat-icon>menu</mat-icon>{{ getMenuCount(role) }}</span>
            </td>
            <td class="rl-c-n">
              <span class="rl-badge rl-badge-mod"><mat-icon>lock_open</mat-icon>{{ getModuleCount(role) }}</span>
            </td>
            <td>
              <span class="rl-status" [class.active]="role.status === 'active'">
                {{ role.status === 'active' ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="rl-c-act" (click)="$event.stopPropagation()">
              <button class="rl-icon-btn" (click)="openEdit(role, $event)" title="Edit"><mat-icon>edit</mat-icon></button>
              <button class="rl-icon-btn rl-icon-del" *ngIf="!role.isSystem"
                      (click)="deleteRole(role, $event)" title="Delete"><mat-icon>delete_outline</mat-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-container>

  <ng-container *ngIf="activeTab === 'users'">

    <div class="rl-users-ctrl">
      <div class="rl-search-wrap">
        <mat-icon>search</mat-icon>
        <input class="rl-search-input" [(ngModel)]="userSearch" (ngModelChange)="onUserSearchChange()" placeholder="Search by name, email or ID…">
        <button class="rl-clear-btn" *ngIf="userSearch" (click)="userSearch = ''; onUserSearchChange()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <app-custom-select class="rl-role-filter" [options]="roleFilterOptions"
              bindLabel="label" bindValue="value"
              [(ngModel)]="roleFilter" (ngModelChange)="onRoleFilterChange()"
              placeholder="All Roles"></app-custom-select>
    </div>

    <div class="rl-loading" *ngIf="usersLoading">
      <mat-spinner diameter="24"></mat-spinner><span>Loading users…</span>
    </div>

    <div class="rl-empty" *ngIf="!usersLoading && filteredUsers.length === 0">
      <div class="rl-empty-icon"><mat-icon>people</mat-icon></div>
      <h3>No users found</h3>
      <p>{{ userSearch || roleFilter ? 'Try clearing your filters.' : 'No users in the system.' }}</p>
    </div>

    <div class="rl-users-table-wrap" *ngIf="!usersLoading && filteredUsers.length > 0">
      <table class="rl-users-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Employee ID</th>
            <th>Email</th>
            <th>Role</th>
            <th>Session Timeout</th>
            <th>Account</th>
            <th>Status</th>
            <th class="rl-th-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of pagedUsers">
            <td>
              <div class="rl-user-cell">
                <div class="rl-user-avatar" [style.background]="getRoleColor({name: user.role}) + '20'"
                     [style.color]="getRoleColor({name: user.role})">
                  {{ getUserInitials(user) }}
                </div>
                <div class="rl-user-info">
                  <span class="rl-user-name">{{ user.firstName }} {{ user.lastName }}</span>
                  <span class="rl-user-dept" *ngIf="user.designation">{{ user.designation }}</span>
                </div>
              </div>
            </td>
            <td><span class="rl-emp-id">{{ user.employeeId }}</span></td>
            <td><span class="rl-user-email">{{ user.email }}</span></td>
            <td>
              <div class="rl-assign-cell">
                <app-custom-select class="rl-sel" [options]="roleOptions" bindLabel="label" bindValue="value"
                        [ngModel]="user.role" [ngModelOptions]="{standalone:true}"
                        (ngModelChange)="assignRole(user, $event)"
                        [disabled]="changingRoleFor === user.id" placeholder="Select Role"></app-custom-select>
                <mat-spinner *ngIf="changingRoleFor === user.id" diameter="16"></mat-spinner>
              </div>
            </td>
            <td>
              <div class="rl-assign-cell">
                <app-custom-select class="rl-sel" [options]="sessionOptions" bindLabel="label" bindValue="value"
                        [ngModel]="user.sessionTimeoutMinutes ?? ''" [ngModelOptions]="{standalone:true}"
                        (ngModelChange)="setSessionTimeout(user, $event)"
                        [disabled]="savingSessionFor === user.id" placeholder="Default"></app-custom-select>
                <mat-spinner *ngIf="savingSessionFor === user.id" diameter="16"></mat-spinner>
              </div>
            </td>
            <td>
              <div class="rl-cred" [ngClass]="'rl-cred-' + credStatus(user).key">
                <span class="rl-cred-badge">
                  <mat-icon>{{ credStatus(user).icon }}</mat-icon>{{ credStatus(user).label }}
                </span>
                <span class="rl-cred-detail">{{ credStatus(user).detail }}</span>
              </div>
            </td>
            <td>
              <label class="rl-status-toggle" [class.on]="isUserActive(user)"
                     [title]="isUserActive(user) ? 'Active — click to deactivate' : 'Inactive — click to activate'">
                <input type="checkbox" [checked]="isUserActive(user)"
                       [disabled]="togglingStatusFor === user.id" (change)="toggleUserStatus(user)">
                <span class="rl-toggle-track"></span>
                <span class="rl-toggle-lbl">{{ isUserActive(user) ? 'Active' : 'Inactive' }}</span>
                <mat-spinner *ngIf="togglingStatusFor === user.id" diameter="14"></mat-spinner>
              </label>
            </td>
            <td class="rl-td-actions">
              <div class="rl-user-actions">
                <button class="rl-user-act-btn" (click)="openChangePassword(user)" title="Reset password">
                  <mat-icon>lock_reset</mat-icon>
                </button>
                <button class="rl-user-act-btn rl-user-act-share" (click)="shareCredentials(user)"
                        [disabled]="sharingCredsFor === user.id"
                        [title]="credStatus(user).key === 'not-shared' ? 'Send credentials via email' : 'Resend credentials via email'">
                  <mat-spinner *ngIf="sharingCredsFor === user.id" diameter="15"></mat-spinner>
                  <mat-icon *ngIf="sharingCredsFor !== user.id">{{ credStatus(user).key === 'not-shared' ? 'send' : 'forward_to_inbox' }}</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <app-pagination
        [total]="filteredUsers.length"
        [page]="usersPage"
        [pageSize]="usersPageSize"
        (pageChange)="usersPage = $event"
        (pageSizeChange)="usersPageSize = $event; usersPage = 1">
      </app-pagination>
    </div>

  </ng-container>

  </ng-container>

  <ng-container *ngIf="showDialog">
  <div class="rl-overlay" (click)="closeDialog()"></div>
  <div class="rl-drawer">

    <ng-container *ngIf="drawerMode === 'view' && selectedRole">
      <div class="rl-dw-hero">
        <div class="rl-dw-hero-top">
          <button class="rl-dw-back" (click)="closeDialog()">
            <mat-icon>arrow_back</mat-icon> Roles &amp; Permissions
          </button>
          <div style="display:flex;gap:6px;align-items:center">
            <button class="rl-dw-edit-btn" (click)="openEdit(selectedRole, $event)">
              <mat-icon>edit</mat-icon> Edit
            </button>
          </div>
        </div>
        <div class="rl-dw-hero-main">
          <div class="rl-dw-hero-icon">
            <mat-icon>{{ getRoleIcon(selectedRole) }}</mat-icon>
          </div>
          <div>
            <div class="rl-dw-hero-badge">
              <span *ngIf="selectedRole.isSystem">System · </span>{{ selectedRole.status === 'active' ? 'Active' : 'Inactive' }}
            </div>
            <div class="rl-dw-hero-title">{{ selectedRole.displayName || selectedRole.name }}</div>
            <div class="rl-dw-hero-sub">{{ selectedRole.description || 'No description provided' }}</div>
          </div>
        </div>
      </div>

      <div class="rl-dw-body">
        <div class="rl-dw-section">
          <div class="rl-dw-section-title"><mat-icon>menu</mat-icon> Menu Access &nbsp;<span style="font-weight:400;text-transform:none;letter-spacing:0">({{ getSelectedMenuKeys().length }} items)</span></div>

          <div class="rl-rail-wrap" style="margin-top:12px">
            <div class="rl-rail">
              <button type="button" class="rl-rail-btn" *ngFor="let s of sectionDefs"
                      [class.active]="activeSectionKey === s.key" (click)="selectSection(s.key)">
                <mat-icon>{{ s.icon }}</mat-icon>
                <span>{{ s.short }}</span>
                <span class="rl-rail-dot" *ngIf="sectionGrantedCountView(s.key) > 0"></span>
              </button>
            </div>

            <div class="rl-flyout" *ngIf="activeSectionKey as ak">
              <div class="rl-flyout-head">
                <span class="rl-flyout-title">{{ getSectionLabel(ak) }}</span>
                <span class="rl-flyout-count">{{ sectionGrantedCountView(ak) }}/{{ pagesForSection(ak).length }}</span>
              </div>

              <div class="rl-tree rl-tree--ro rl-tree--flat">
                <div class="rl-tree-node" *ngFor="let m of pagesForSection(ak)">
                  <div class="rl-tree-row">
                    <button type="button" class="rl-tree-toggle" *ngIf="allTabsForMenu(m.key).length" (click)="toggleExpand(m.key)">
                      <mat-icon>{{ isExpanded(m.key) ? 'remove' : 'add' }}</mat-icon>
                    </button>
                    <span class="rl-tree-toggle-spacer" *ngIf="!allTabsForMenu(m.key).length"></span>
                    <input type="checkbox" class="rl-tree-checkbox" [checked]="getSelectedMenuKeys().includes(m.key)" disabled>
                    <mat-icon class="rl-tree-icon">{{ m.icon }}</mat-icon>
                    <span class="rl-tree-label" [class.rl-tree-label--off]="!getSelectedMenuKeys().includes(m.key)">{{ m.label }}</span>
                    <span class="rl-tree-count" *ngIf="allTabsForMenu(m.key).length"
                          [class.rl-tree-count--full]="viewTabCount(m.key) === allTabsForMenu(m.key).length && viewTabCount(m.key) > 0"
                          [class.rl-tree-count--partial]="viewTabCount(m.key) > 0 && viewTabCount(m.key) < allTabsForMenu(m.key).length">
                      {{ viewTabCount(m.key) }}/{{ allTabsForMenu(m.key).length }}
                    </span>
                  </div>
                  <div class="rl-tree-children" *ngIf="isExpanded(m.key) && allTabsForMenu(m.key).length">
                    <label class="rl-tree-child" *ngFor="let t of allTabsForMenu(m.key)">
                      <input type="checkbox" [checked]="getSelectedTabKeys().includes(t.key)" disabled>
                      <span>{{ t.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="rl-dw-foot">
        <button class="rl-btn rl-btn-ghost" (click)="closeDialog()">Close</button>
        <button class="rl-btn rl-btn-primary" *ngIf="!selectedRole.isSystem" (click)="openEdit(selectedRole, $event)">
          <mat-icon>edit</mat-icon> Edit Role
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="drawerMode === 'edit'">
      <div class="rl-dw-hero">
        <div class="rl-dw-hero-top">
          <button class="rl-dw-back" (click)="closeDialog()">
            <mat-icon>arrow_back</mat-icon> Roles &amp; Permissions
          </button>
        </div>
        <div class="rl-dw-hero-main">
          <div class="rl-dw-hero-icon">
            <mat-icon>{{ isEdit ? 'edit' : 'add_moderator' }}</mat-icon>
          </div>
          <div>
            <div class="rl-dw-hero-badge">{{ isEdit ? 'Edit Role' : 'New Role' }}</div>
            <div class="rl-dw-hero-title">{{ isEdit ? (roleForm.displayName || roleForm.name || 'Edit Role') : 'Create New Role' }}</div>
            <div class="rl-dw-hero-sub">{{ isEdit ? 'Update permissions and menu access for this role' : 'Define what this role can see and do across the system' }}</div>
          </div>
        </div>
      </div>

      <div class="rl-dw-body">
        <div class="rl-dw-section">
          <div class="rl-dw-section-title"><mat-icon>info</mat-icon> Basic Information</div>
          <div class="rl-form-row" style="margin-top:10px">
            <div class="rl-field rl-field-grow">
              <label>Role Name <span class="req">*</span></label>
              <input [(ngModel)]="roleForm.name" placeholder="e.g. hr_manager" [disabled]="isEdit && roleForm.isSystem">
            </div>
            <div class="rl-field rl-field-grow">
              <label>Display Name</label>
              <input [(ngModel)]="roleForm.displayName" placeholder="e.g. HR Manager">
            </div>
            <div class="rl-field">
              <label>Status</label>
              <select [(ngModel)]="roleForm.status">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
          <div class="rl-field" style="margin-top:6px">
            <label>Description</label>
            <textarea [(ngModel)]="roleForm.description" rows="2" placeholder="Describe the role's purpose…"></textarea>
          </div>
        </div>

        <div class="rl-dw-section">
          <div class="rl-dw-section-header">
            <div class="rl-dw-section-title"><mat-icon>menu</mat-icon> Menu Access</div>
            <label class="rl-check-label">
              <input type="checkbox" [checked]="allMenusSelected()" (change)="toggleAllMenus()">
              <span>Select All</span>
            </label>
          </div>
          <p class="rl-menu-hint">Pick a section on the left, then grant its pages. Expand a page to pick which sub-menus (tabs) this role can open.</p>

          <div class="rl-rail-wrap" style="margin-top:12px">
            <div class="rl-rail">
              <button type="button" class="rl-rail-btn" *ngFor="let s of sectionDefs"
                      [class.active]="activeSectionKey === s.key" (click)="selectSection(s.key)">
                <mat-icon>{{ s.icon }}</mat-icon>
                <span>{{ s.short }}</span>
                <span class="rl-rail-dot" *ngIf="sectionGrantedCount(s.key) > 0"></span>
              </button>
            </div>

            <div class="rl-flyout" *ngIf="activeSectionKey as ak">
              <div class="rl-flyout-head">
                <span class="rl-flyout-title">{{ getSectionLabel(ak) }}</span>
                <span class="rl-flyout-count">{{ sectionGrantedCount(ak) }}/{{ pagesForSection(ak).length }}</span>
              </div>

              <div class="rl-tree rl-tree--flat">
                <div class="rl-tree-node" *ngFor="let m of pagesForSection(ak)">
                  <div class="rl-tree-row">
                    <button type="button" class="rl-tree-toggle" *ngIf="allTabsForMenu(m.key).length" (click)="toggleExpand(m.key)">
                      <mat-icon>{{ isExpanded(m.key) ? 'remove' : 'add' }}</mat-icon>
                    </button>
                    <span class="rl-tree-toggle-spacer" *ngIf="!allTabsForMenu(m.key).length"></span>
                    <input type="checkbox" class="rl-tree-checkbox" [checked]="isMenuSelected(m.key)" (change)="toggleMenu(m.key)">
                    <mat-icon class="rl-tree-icon">{{ m.icon }}</mat-icon>
                    <span class="rl-tree-label">{{ m.label }}</span>
                    <span class="rl-tree-count" *ngIf="allTabsForMenu(m.key).length"
                          [class.rl-tree-count--full]="selectedTabCountForMenu(m.key) === allTabsForMenu(m.key).length && selectedTabCountForMenu(m.key) > 0"
                          [class.rl-tree-count--partial]="selectedTabCountForMenu(m.key) > 0 && selectedTabCountForMenu(m.key) < allTabsForMenu(m.key).length">
                      {{ selectedTabCountForMenu(m.key) }}/{{ allTabsForMenu(m.key).length }}
                    </span>
                  </div>

                  <div class="rl-tree-children" *ngIf="isExpanded(m.key) && allTabsForMenu(m.key).length">
                    <label class="rl-tree-child" *ngFor="let t of allTabsForMenu(m.key)" [class.disabled]="!isMenuSelected(m.key)">
                      <input type="checkbox" [checked]="isTabSelected(t.key)" [disabled]="!isMenuSelected(m.key)" (change)="toggleTab(t.key)">
                      <span>{{ t.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="rl-dw-foot">
        <button class="rl-btn rl-btn-ghost" (click)="closeDialog()">Cancel</button>
        <button class="rl-btn rl-btn-primary" (click)="submitRole()"
                [disabled]="submitting || !roleForm.name">
          <mat-icon>{{ submitting ? 'hourglass_empty' : (isEdit ? 'save' : 'add') }}</mat-icon>
          {{ submitting ? 'Saving…' : (isEdit ? 'Save Changes' : 'Create Role') }}
        </button>
      </div>
    </ng-container>

  </div>
  </ng-container>

</div>

<ng-container *ngIf="showPwdDialog">
  <div class="rl-overlay" (click)="closeChangePassword()"></div>
  <div class="rl-pwd-modal">
    <div class="rl-pwd-head">
      <div class="rl-pwd-head-icon"><mat-icon>lock_reset</mat-icon></div>
      <div>
        <h3>Change Password</h3>
        <p>Set a new password for <strong>{{ pwdUser?.firstName }} {{ pwdUser?.lastName }}</strong></p>
      </div>
      <button class="rl-pwd-close" (click)="closeChangePassword()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="rl-pwd-body">
      <div class="rl-pwd-field">
        <div class="rl-pwd-label-row">
          <label>New Password</label>
          <button type="button" class="rl-pwd-gen" (click)="generatePassword()">
            <mat-icon>autorenew</mat-icon> Generate
          </button>
        </div>
        <div class="rl-pwd-input-wrap">
          <input [type]="showPwdText ? 'text' : 'password'" [(ngModel)]="pwdForm.newPassword"
                 placeholder="At least 8 characters" autocomplete="new-password">
          <button type="button" class="rl-pwd-eye" (click)="showPwdText = !showPwdText">
            <mat-icon>{{ showPwdText ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
      </div>
      <div class="rl-pwd-field">
        <label>Confirm Password</label>
        <input [type]="showPwdText ? 'text' : 'password'" [(ngModel)]="pwdForm.confirmPassword"
               placeholder="Re-enter new password" autocomplete="new-password">
      </div>
    </div>
    <div class="rl-pwd-foot">
      <button class="rl-btn rl-btn-ghost" (click)="closeChangePassword()">Cancel</button>
      <button class="rl-btn rl-btn-primary" (click)="submitChangePassword()"
              [disabled]="pwdSubmitting || !pwdForm.newPassword || !pwdForm.confirmPassword">
        <mat-icon>{{ pwdSubmitting ? 'hourglass_empty' : 'check' }}</mat-icon>
        {{ pwdSubmitting ? 'Saving…' : 'Update Password' }}
      </button>
    </div>
  </div>
</ng-container>
